import BuiltInDropdown from '@anm/components/BuiltInDropdown';
import { FC } from 'react';

import DropdownContent, { ListContentProps } from './DropdownContent';
import { MenuDropdownIconButton } from './Wrapper';

type MenuDropdownProps = ListContentProps;

const ResourcesMenuDropdown: FC<MenuDropdownProps> = ({ list }) => {
  return (
    <BuiltInDropdown maxWindowHeight={720} renderContent={() => <DropdownContent {...{ list }} />}>
      <MenuDropdownIconButton size="upper-medium" variant="light-blue-lowercase" icon="images/icons/resources-nav.svg">
        Resources
      </MenuDropdownIconButton>
    </BuiltInDropdown>
  );
};

export default ResourcesMenuDropdown;
